"use strict";

//language=Markdown
let doc = `

##Опции
|Опция|Тип|Дефолт|Описание|
|---|---|---|---|
|html|Object|\`PF.List.templates\`|Объект с HTML|
|html.wrapper|String|\`PF.List.templates.wrapper\`|HTML обёртки списка|
|title|String, Function|\`&nbsp;\`|Заголовок списка|
|searchable|Bool|true|Включат поиск по списку|
|search|String|true|Правило фильтрации, добавляется к фильтру models операндом "И"|
|searchLabel|String|Поиск|Лэйбл строки поиска|
|addable|Bool|false|Включает возможность добавления модели. В классе отображения модели унаследованном от PF.List.Item должы быть: get formTemplate(), options.formConfig|
|editable|Bool|false|Включает возможность редактирования модели. В классе отображения модели унаследованном от PF.List.Item должы быть: get formTemplate(), options.formConfig|
|addTo|String['begin','end']|begin|Определяет добавление нового итема в начало или конец списка|
|models|PF.Models|undefined|Массив моделей|
|modelsConfig|Object|{}|Если не models определён, используется для создания нового экземпляра PF.Models|
|itemClass|Class, Function|PF.List.Item|Класс элемента списка|
|dummyText|String|Нет данных|Текс заглушки, отображется, когда models пустой (filterLength === 0)|
|enableDummy|Bool|true|Включает отображение заглушки|
|sortable|Bool|true|Включает возможность сортировки списка, в itemTemplate необходим элемент с атрибутом pf="dnd"|
|serialIndex|String|serial_num|Ключ для значений индексов при сортировке|
|sortDir|String['v','h']|v|Направление ортировки - вертиканая или горизонтальная





##События
|Событие |Описание|
|---|---|
|add-success| Срабатывает, когда в models добавляется модель с \`isNewRecord === true\`|`;

PF.List = class List extends PF.Dom.List
	{
	static get options()
		{
		return {
			// dom: {
			// 	element: undefined,
			// 	scrollTarget: undefined,
			// },
			html: PF.List.templates,
			title: '&nbsp;',

			enableHeader: true,
			enableDummy: true,
			dummyText: "Нет данных",

			searchable: true,
			// search: '@{name}',
			searchLabel: 'Поиск',
			searchConfig: `@{name} ~ @{list.searchField}`,

			addable: false,
			editable: false,
			addTo: 'begin', //end

			models: undefined,
			modelsConfig: {filterConfig: {rule: ''}},
			itemClass: PF.List.Item,

			sortable: false,
			serialIndex: 'serial_num',
			sortDir: 'v', //h
			showRemoved: false,
			listTitle: false,

			itemEditTrait: PF.List.Item.Edit,
			itemDndTrait: PF.List.Item.Dnd,
			addTrait: PF.List.Add,
			searchTrait: PF.List.Search
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			header: `
				<div class="pf-list-crud-header" pf="header">

					<div class="title-row" pf="titleRow">
						<div class="title" pf="title"></div>
						<div class="search-box" pf="searchBox">
							<input class="" type="text" pf="search"/>
						</div>
					</div>
					<div class="actions">
						<a class="link" style="display: none" class="search-toggle" pf="searchToggle"><i class="material-icons">search</i></a>
						<a class="link" style="display: none" pf="add"><i class="material-icons">add</i></a>
						<a class="link" style="display: none" pf="selectAll"><i class="material-icons">select_all</i></a>
						<a class="link" style="display: none" pf="delete"><i class="material-icons">delete</i></a>
					</div>
				</div>
			`,
			//language=HTML
			wrapper: `
				<div class="pf-list-wrapper" pf="wrapper">
					<div pf="pfListTitle"></div>
					<ul pf="ul">

					</ul>
					<div class="preloader-container" pf="preloaderContainer">
						<div class="preloader" pf="preloader"></div>
					</div>
					<div class="pf-list-dummy" pf="dummy"><p pf="dummyText"></p>
					</div>
				</div>
			`,
			//language=HTLM
			preloaderContent: `
				<span class="preloader-inner">
					<span class="preloader-inner-gap"></span>
					<span class="preloader-inner-left">
						<span class="preloader-inner-half-circle"></span>
					</span>
					<span class="preloader-inner-right">
						<span class="preloader-inner-half-circle"></span>
					</span>
				</span>
			`,
			//language=HTLM
			dndDummy: `
				<div class="" pf="dndDummy"></div>
				`
		};
		}

	init()
		{
		super.init();

		if (this.dom.preloaderContainer !== undefined)
			{
			this.dom.preloader.append(this.dom.preloaderContent);
			this.bindDom({preloaderContainer: 'show'}, 'models.loading');
			}
		if (this.dom.dummy !== undefined)
			{
			this.bindDom({dummy: 'show'}, [
				'models.filterLength',
				'models.loading',
				'enableDummy'
			], (filterLength, loading, enableDummy) => filterLength === 0 && loading === false && enableDummy === true);
			this.bindDom({dummy: 'html'}, 'dummyText');
			}
		if (this.dom.scrollTarget !== undefined)
			{
			this.dom.scrollTarget.on('scroll', () => this.scrollSlot());
			this.models.on('load-part', () => this.scrollSlot());
			}

		this.dom.element.addClass('pf-list');
		this.dom.element.classes.list = this.dom.ul.node.tagName === "UL";

		if (this.listTitle == true) {			
			this.dom.load(this.dom.rendererTitle, 'listTitle');
			this.dom.pfListTitle.prepend(this.dom.listTitle);
		}

		if (this.dom.header !== undefined)
			{
			this.dom.element.prepend(this.dom.header);
			this.bindDom({header: 'show'}, 'enableHeader');
			this.bindDom({title: 'html'}, 'title');
			}

		this.useTrait(this.searchTrait, this.searchable && this.enableHeader);
		this.useTrait(this.addTrait, this.addable);
		}


	};


PF.List.Item = class Item extends PF.Dom.List.Item
	{
	static get options()
		{
		return {
			title: `@{model.name}`,
			newTitle: `Создать`,
		};
		}

	init()
		{
		super.init();
		this.useTrait(this.list.itemEditTrait, this.list.addable || this.list.editable);
		}

	onRender()
		{
		super.onRender();

		this.useTrait(PF.List.Item.Dnd, this.get('list.sortable', false, false));
		}
	};
